import { render } from "./FamilyInfoStepComponent.vue?vue&type=template&id=397b5316&ts=true"
import script from "./FamilyInfoStepComponent?vue&type=script&lang=ts"
export * from "./FamilyInfoStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__